import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import LoadingCircle from '../LoadingCircle';
import Button from '../../../components/Button';

import { markRecommendedActionAsDone } from '../../actions/testResult';

import './index.scss';

const ToggleStateButton = ({
  cta,
  done,
  timingKey,
  contentKey,
  dispatch,
  language,
  markAsCompleteButtonLoading,
}) => {
  const { testCode } = useParams();
  const [isLoading, setIsLoading] = React.useState(false);

  const wrapperRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (isLoading && !markAsCompleteButtonLoading) {
      setIsLoading(false);
    }
  }, [markAsCompleteButtonLoading, isLoading]);

  const getButtonText = () => {
    return done ? cta.secondStateText : cta.firstStateText;
  };

  const handleOnClick = () => {
    const target = buttonRef.current;

    // We are calculating the width and height of the button so we can keep width and height of the button when it is loading
    if (target && wrapperRef.current) {
      const rect = target.getBoundingClientRect();
      const widthOfButton = Math.ceil(rect.width);
      const heightOfButton = Math.ceil(rect.height);

      wrapperRef.current.style.setProperty(
        '--toggle-state-button-width',
        `${widthOfButton}px`);
      wrapperRef.current.style.setProperty(
        '--toggle-state-button-height',
        `${heightOfButton}px`,
      );
    }

    setIsLoading(true);
    dispatch(
      markRecommendedActionAsDone(
        testCode,
        timingKey,
        contentKey,
        true,
        language,
      ),
    );
  };

  return (
    <div
      className={cx({ 'toggle-state-button--loading': isLoading })}
      ref={wrapperRef}
    >
      <Button
        key={cta.firstStateText || cta.secondStateText}
        variant={cta.variant}
        disabled={cta.disabled}
        size='small'
        onClick={handleOnClick}
        className={cx('toggle-state-button__button')}
        innerRef={buttonRef}
      >
        {isLoading ? <LoadingCircle /> : getButtonText()}
      </Button>
    </div>
  );
};

ToggleStateButton.propTypes = {
  cta: PropTypes.object,
  dispatch: PropTypes.func,
  markAsCompleteButtonLoading: PropTypes.bool,
  language: PropTypes.string,
  timingKey: PropTypes.string,
  contentKey: PropTypes.string,
  done: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  markAsCompleteButtonLoading: state.testResult.get(
    'markAsCompleteButtonLoading',
  ),
});

export default connect(mapStateToProps)(ToggleStateButton);
